// extracted by mini-css-extract-plugin
export default {"page-content":"invitations_page-content__6IrWL"};